module.exports = __webpack_public_path__ + "static/media/icons_Bilan Syndrôme d_Hyperventilation.a01ccc55.svg";